import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiPlay } from 'react-icons/fi';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      id: 1,
      image: 'https://cdnbailebelle.pages.dev/hero-banner/1.jpg',
      mobileImage: 'https://cdnbailebelle.pages.dev/hero-banner/mobile/1.jpg',
      title: 'Elegant Ballerina Dresses',
      subtitle: 'Discover our exquisite collection of premium constumes',
      cta: 'Shop Dresses',
      link: '/products',
    },
    {
      id: 2,
      image: 'https://cdnbailebelle.pages.dev/hero-banner/2.jpg',
      mobileImage: 'https://cdnbailebelle.pages.dev/hero-banner/mobile/2.jpg',
      title: 'Stunning Jewelry',
      subtitle: 'Complete your look with our beautiful accessories',
      cta: 'Shop Jewelry',
      link: '/products',
    },
    {
      id: 3,
      image: 'https://cdnbailebelle.pages.dev/hero-banner/3.jpg',
      mobileImage: 'https://cdnbailebelle.pages.dev/hero-banner/mobile/3.jpg',
      title: 'Professional Costumes',
      subtitle: 'Premium quality costumes for performances and competitions',
      cta: 'Shop Costumes',
      link: '/products',
    },

    {
      id: 5,
      image: 'https://cdnbailebelle.pages.dev/hero-banner/5.jpg',
      mobileImage: 'https://cdnbailebelle.pages.dev/hero-banner/mobile/5.jpg',
      title: 'Dress & Collections',
      subtitle: 'Explore a stunning range of dresses and curated collections',
      cta: 'Shop Collections',
      link: '/products',
    },
    {
      id: 6,
      image: 'https://cdnbailebelle.pages.dev/hero-banner/1.jpg',
      mobileImage: 'https://cdnbailebelle.pages.dev/hero-banner/mobile/6.jpg',
      title: 'Luxury Shoes',
      subtitle: 'Step into excellence with our professional footwear',
      cta: 'Shop Shoes',
      link: '/products',
    },
    {
      id: 7,
      image: 'https://cdnbailebelle.pages.dev/hero-banner/2.jpg',
      mobileImage: 'https://cdnbailebelle.pages.dev/hero-banner/mobile/7.jpg',
      title: 'Elegant Accessories',
      subtitle: 'Complete your dance ensemble with our stunning accessories',
      cta: 'Shop Accessories',
      link: '/products',
    },

  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="relative h-[60vh] min-h-[400px] max-h-[600px] overflow-hidden">
      {/* Background Images */}
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {/* Desktop Image */}
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover hidden md:block"
            />
            {/* Mobile Image */}
            <img
              src={slide.mobileImage}
              alt={slide.title}
              className="w-full h-full object-cover block md:hidden object-center"
            />
            <div className="absolute inset-0 bg-black bg-opacity-30 md:bg-opacity-40" />
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center md:justify-start">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl mx-auto md:mx-0 text-center md:text-left">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 sm:mb-3 md:mb-4 animate-fadeInUp leading-tight">
              {slides[currentSlide].title}
            </h1>
            <p className="text-xs sm:text-sm md:text-base lg:text-lg text-gray-200 mb-3 sm:mb-4 md:mb-5 animate-fadeInUp animation-delay-200 leading-relaxed max-w-xl mx-auto md:mx-0">
              {slides[currentSlide].subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 animate-fadeInUp animation-delay-400 justify-center md:justify-start">
              <Link
                to={slides[currentSlide].link}
                className="inline-flex items-center justify-center px-3 sm:px-4 md:px-5 py-2 sm:py-2.5 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 text-xs sm:text-sm"
                style={{ backgroundColor: '#CF0F63' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#B00D56'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#CF0F63'}
              >
                {slides[currentSlide].cta}
                <FiArrowRight className="ml-1 sm:ml-1.5" size={14} />
              </Link>
              <button className="inline-flex items-center justify-center px-3 sm:px-4 md:px-5 py-2 sm:py-2.5 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-all duration-300 hover:scale-105 text-xs sm:text-sm">
                <FiPlay className="mr-1 sm:mr-1.5" size={14} />
                Watch Video
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-2 sm:bottom-4 md:bottom-6 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex space-x-1 sm:space-x-1.5">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'bg-white scale-110' : 'bg-white bg-opacity-50 hover:bg-opacity-75'
              }`}
              style={index === currentSlide ? { backgroundColor: '#CF0F63' } : {}}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Scroll Indicator - Hidden on mobile */}
      <div className="absolute bottom-8 right-8 z-10 animate-bounce hidden lg:block">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
